module.exports = __webpack_public_path__ + "img/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.754005a7.webp";